import { useEffect, useState } from 'react';

// Count-up animation for headline figures (premium micro-motion).
// Eases to the target over `ms`; falls back instantly where rAF is
// unavailable, and respects reduced-motion via a quick settle.
export function useCountUp(target: number, ms = 900): number {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (typeof performance === 'undefined' || typeof requestAnimationFrame === 'undefined') {
      setN(target);
      return;
    }
    let raf = 0;
    const start = performance.now();
    const tick = (t: number) => {
      const p = Math.min(1, (t - start) / ms);
      setN(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, ms]);
  return n;
}
